import type { Dispatch } from "@reduxjs/toolkit";
import {
  ChangeAlign,
  ChangeBold,
  ChangeColor,
  ChangeSize,
  EditorInter,
  UnderLine,
} from "../reducers/editor";

/** contentEditable 선택 기준으로 툴바 Redux 상태 동기화 */
export function syncEditorToolbarFromSelection(
  dispatch: Dispatch,
  screenEl: HTMLElement | null,
  editorState: EditorInter
): void {
  if (!screenEl) return;

  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) return;

  const range = sel.getRangeAt(0);
  if (!screenEl.contains(range.commonAncestorContainer)) return;

  const focusNode = sel.focusNode;
  if (!focusNode) return;

  const parentEl =
    focusNode.nodeType === Node.ELEMENT_NODE
      ? (focusNode as Element)
      : focusNode.parentElement;
  if (!parentEl) return;

  const style = window.getComputedStyle(parentEl);
  const fontSize = parseInt(style.fontSize, 10);
  const align = style.textAlign;
  const bold = document.queryCommandState("bold");
  const underline = document.queryCommandState("underline");
  const color = document.queryCommandValue("ForeColor");

  if (!isNaN(fontSize) && fontSize !== editorState.size) {
    dispatch(ChangeSize(fontSize));
  }
  if (underline !== editorState.underline) {
    dispatch(UnderLine(underline));
  }
  if (bold !== editorState.bold) {
    dispatch(ChangeBold(bold));
  }
  if (align !== editorState.align && align !== "start") {
    dispatch(ChangeAlign(align));
  }
  if (color !== editorState.color) {
    dispatch(ChangeColor(color || undefined));
  }
}
